import {
  Group,
} from "three";

import { Terrain } from './terrain'
import { Plane } from './plane'

class Scenery {

  constructor( camera ) {

    const voxel = ( window.CONFIG && window.CONFIG.brick ) ? window.CONFIG.brick.voxel :  16;
    const addSurface = ( window.CONFIG && window.CONFIG.road ) ? window.CONFIG.road.surface :  true;
    const scenery = new Group();

    // MAIN TERRAIN
    const floorcloth = new Terrain( 'grass', voxel*64, voxel*32, 0x1e4735, voxel*2 ); // or Floorcloth
    floorcloth.position.x -= voxel; // this centers it to the bricks (which start negative 1xvoxel )
    floorcloth.updateMatrix();// update it once only if static and using matrixAutoUpdate false

    // BACKCLOTH
    const backcloth = new Plane( 'backcloth', voxel*128, voxel*64, 0x87ceeb); // or Backcloth
    backcloth.position.z -= voxel*32;
    backcloth.position.z -= voxel*16;
    backcloth.position.y -= voxel*6;
    backcloth.rotation.x -= Math.atan2( ( camera.position.y - backcloth.position.y ), ( camera.position.z - backcloth.position.z ) ) ;
    backcloth.updateMatrix();// update it once only if static and using matrixAutoUpdate false

    // HILLS
    
    const clouds = new Plane( 'clouds', ( window.innerWidth <  600 ) ? voxel*112 : voxel*128, ( window.innerWidth <  600 ) ? voxel*56 : voxel*64, 0x5d7e58 );
    clouds.position.z -= voxel*32;
    clouds.position.z -= voxel*12;
    clouds.position.y -= voxel*6;
    
    clouds.rotation.x -= Math.atan2( ( camera.position.y - clouds.position.y ), ( camera.position.z - clouds.position.z ) );
    clouds.updateMatrix();// update it once only if static and using matrixAutoUpdate false

    // HILLS
    const hills = new Plane( 'hills', voxel*128, voxel*64, 0x5d7e58 );
    hills.position.z -= voxel*32;
    hills.position.z -= voxel*8;
    hills.position.y -= voxel*6;
    hills.rotation.x -= Math.atan2( ( camera.position.y - hills.position.y ), ( camera.position.z - hills.position.z ) );
    hills.updateMatrix();// update it once only if static and using matrixAutoUpdate false

    // ADD THEM
    scenery.floorcloth = floorcloth; // used for object gravity
    scenery.add(floorcloth);
    scenery.add(backcloth);
    scenery.add(clouds);
    scenery.add(hills);

    // ADD ROAD SURFACE
    /* TODO: if adding this, then it needs to map to terrain and not be flat */
    if( addSurface ){
      const road = new Plane( 'road', voxel*8, voxel*16, 0xBFA674, false );
      road.position.y += 0.1
      // road.rotation.x = 0.1;
      scenery.add(road);
    }

    /* RETURN TEH SCENERY */
    scenery.position.y -= 64;
    return scenery;
  }
}

export { Scenery };